import { formatDate } from './formatDate.function';

export function constDatesFilter(dateFilter: any, zero: boolean, gmt: boolean): string{
    let d = new Date(dateFilter);
    if(zero)
    {
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);
      d.setMilliseconds(0);
    }
    else
    {
      d.setHours(23);
      d.setMinutes(59);
      d.setSeconds(59);
      d.setMilliseconds(59);
    }
    if(gmt)
        return d.toISOString();
    return formatDate(d);
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/functions/constDatesFilter.function.ts